import React from 'react'
import connectField from 'uniforms/connectField'

import DatePicker from '../../../DatePicker'

const CustomDate = (props) => {
  const { label } = props

  return (
    <DatePicker
      clearable={true}
      label={label}
      valueDate={props.value || null}
      onChangeDate={(date) => props.onChange(!!date ? date.toDate() : null)}
      birthdayMode={props.birthdayMode || false}
    />
  )
}

export default connectField(CustomDate)
